import { useMutation, useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";
import { ConsultantBookingById } from "../../api/Consultation/ConsultantBookingById";
import Spinner from "../../components/Shared/Spinner";
import { format, formatDistanceToNow } from "date-fns";
import { Calendar, CircleDotDashed, CircleUser, Phone, Timer } from "lucide-react";
import Button from "../../components/Shared/Button";
import { EditReservation } from "../../api/Consultation/EditReservationStatus";
import { queryClient } from "../../main";
import { toast } from "react-toastify";
const Reservations = () => {
    const { id } = useParams();
    const consultantId = id || "";

    const { data: ConsultantData, isLoading: isConsultantLoading } = useQuery({
        queryFn: () => ConsultantBookingById(consultantId),
        queryKey: ["consultants", consultantId],
        staleTime: 0,
        refetchInterval: 0,
        enabled: !!id,
    });
    const Consultant = ConsultantData?.data;
    const { mutate: mutatePinned } = useMutation({
        mutationFn: ({ status, id }: { status: string, id: string }) =>
            EditReservation({ status }, id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["consultants"] });
            toast.success("Status Updated Successfully");
        },
        onError: (error) => {
            toast.error("Failed to update the Status");
            console.error(error);
        },
    });
    const handleUpdateStatus = (currentStatus: string, id: string) => {
        if (currentStatus === "completed") return;
        const newStatus = "completed"
        mutatePinned({ status: newStatus, id });
    };

    return (
        <div className="py-7">
            <div className="flex justify-between">
                {Consultant && Consultant.length > 0 &&
                    <h1 className="text-burntBlack font-bold text-[32px] mb-7">
                        Consultant Name: <span className="text-secondary">{Consultant[0].consultant.name}</span>
                    </h1>
                }
            </div>
            <div className="p-8 rounded-3xl shadow bg-white border border-black/15">
                <h1 className="mb-10 font-semibold text-2xl">
                    Reservations
                </h1>
                {isConsultantLoading ? (
                    <div className="h-[50vh] flex items-center justify-center">
                        <Spinner />
                    </div>
                ) : (
                    <>
                        {Consultant && Consultant.length > 0 ? (
                            <div className="grid grid-cols-2 gap-10">
                                {Consultant?.map((reservation) => (
                                    <div className="border border-black/15 rounded-2xl p-3 space-y-4">
                                        <div>
                                            <h1 className="text-secondary gap-2 font-semibold flex items-center mb-2">
                                                <CircleUser size={16} /> Personal Information:
                                            </h1>
                                            <div className="flex flex-col">
                                                <p> {reservation.name}</p>
                                                <p> {reservation.email}</p>
                                                <p> {reservation.phone}</p>
                                                {reservation.description}
                                            </div>
                                        </div>
                                        <div>
                                            <h1 className="text-secondary gap-2 font-semibold flex items-center mb-2">
                                                <Calendar size={16} /> Consultation Date:
                                            </h1>
                                            <div>
                                                {reservation.consulantDate.day} {reservation.consulantDate.time}
                                            </div>
                                        </div>

                                        <div>
                                            <h1 className="text-secondary gap-2 font-semibold flex items-center mb-2">
                                                <Timer size={16} /> Reservation Time:
                                            </h1>
                                            <div>
                                                {format(
                                                    new Date(reservation.createdAt),
                                                    "MMMM d, yyyy h:mm a"
                                                )}
                                                &nbsp;&nbsp;
                                                <span className="text-gray-400">
                                                    (
                                                    {formatDistanceToNow(new Date(reservation.createdAt), {
                                                        addSuffix: true,
                                                    })}
                                                    )
                                                </span>
                                            </div>
                                        </div>
                                        <div>
                                            <h1 className="text-secondary gap-2 font-semibold flex items-center mb-2">
                                                <CircleDotDashed size={16} /> Status:
                                            </h1>

                                            <div className="flex gap-2 items-center text-red-500 font-semibold capitalize">
                                                <div className="size-2.5 bg-red-500 rounded-full" />
                                                {reservation.status}
                                            </div>
                                        </div>
                                        <div className="flex gap-4 ">
                                            <Button onClick={() =>
                                                handleUpdateStatus(reservation.status, reservation.id)
                                            } variant="primary" className="!text-xs w-full !h-10" >Change Status</Button>
                                            <Link to={`https://wa.me/${reservation.phone}`}
                                                className="w-full !h-10 hover:bg-[#156221] flex gap-2 items-center justify-center rounded-[10px] text-white bg-[#2ab540] transition-all duration-300 text-xs"><Phone size={16} /> Chat On Whatsapp </Link>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : ('There are no any reserved consultants for this consultant')
                    }
                    </>
                )}
            </div>
        </div>
    );
};

export default Reservations;
